import api from "./api";

export const loginAdmin = (adminLoginRequest) => {
    return api.post("/users/login", adminLoginRequest);
  };